import Vue from 'vue'
import Vuedals from 'vuedals'
import vClickOutside from 'v-click-outside'
import ElementUI from 'element-ui'
import VCalendar from 'v-calendar'
import locale from 'element-ui/lib/locale/lang/en'
import Gravatar from '@/common/components/Gravatar'
import Icon from '@/common/components/Icon'
import VueAcl from '@/core/utils/VueAcl'
import i18n from '@/core/utils/I18n'
import router from '@/core/router'
import store from '@/core/store'
import TopBar from '@/common/components/navigation/TopToolbar'
import Layout from '@/common/components/Layout'
import LeftNav from '@/common/components/navigation/LeftNavigation'
import ElSwitch from '@/common/components/element/ElSwitch'
import ElRow from '@/common/components/element/ElRow'
import ElTable from '@/common/components/element/ElTable'
import ElForm from '@/common/components/element/ElForm'
import VueTour from 'vue-tour'
import FlagIcon from 'vue-flag-icon'
import Zendesk from '@/core/utils/Zendesk'
import { v4 as uuidv4 } from 'uuid'
import { datadogRum } from '@datadog/browser-rum'

import appBootstrap from '@/core/app-bootstrap'
Vue.use(VueTour)
Vue.use(Vuedals)
Vue.use(vClickOutside)
Vue.use(ElementUI, { locale })
Vue.use(VueAcl)
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
Vue.use(FlagIcon)

Vue.use(Zendesk, {
  key: '44230901-c116-4a57-9634-93375d7c329d',
  disabled: false,
  hideOnLoad: true,
  settings: {
    webWidget: {}
  }
})

Vue.component('gravatar', Gravatar)
Vue.component('icon', Icon)
Vue.component('top-bar', TopBar)
Vue.component('layout', Layout)
Vue.component('left-nav', LeftNav)

Vue.component('el-table', ElTable)
Vue.component('el-switch', ElSwitch)
Vue.component('el-row', ElRow)
Vue.component('el-form', ElForm)
Vue.directive('tooltip', {
  bind: function(el) {
    el.addEventListener('mouseover', function(evt) {
      let targetEl = evt.target
      const parentStyles = getComputedStyle(targetEl.parentElement)
      const parentWidth =
        targetEl.parentElement.clientWidth -
        (parseFloat(parentStyles.paddingLeft) +
          parseFloat(parentStyles.paddingRight))
      if (targetEl.offsetWidth > parentWidth) {
        targetEl.setAttribute('title', evt.target.textContent)
      } else {
        targetEl.hasAttribute('title') && targetEl.removeAttribute('title')
      }
    })
  }
})

Vue.config.productionTip = false

appBootstrap().then(() => {
  window.vue = new Vue({
    // eslint-disable-line no-new
    el: '#app',
    template: '#app-template',
    router,
    i18n,
    store,
    mounted() {
      // We emit an event to which non vue components can hook in to if needed
      window.dispatchEvent(new Event('vue-ready'))
      // Hide the Request Help button when XP and the iframe are fully loaded
      if (this.$zendesk) {
        const interval = setInterval(() => {
          const iframe = document.querySelector('#launcher')

          if (iframe) {
            const buttonCt = iframe.contentWindow.document.querySelector(
              '#Embed'
            )
            if (buttonCt) {
              this.$zendesk.hide()
              clearInterval(interval)
            }
          }
        }, 200)
      }
      document.body.setAttribute('qa-id', uuidv4())
    }
  })
})

if (
  window.xp.datadogRum === true &&
  !/Mobi|Android|iPad|iPhone|Tablet/i.test(navigator.userAgent)
) {
  datadogRum.init({
    applicationId: '68ab7174-c8fb-429f-b5c9-4ad17ae6f159',
    clientToken: 'pub434407d73dbf4774ad56d9b77ccea920',
    site: 'datadoghq.eu',
    service: 'xp-web-app',
    env: window.BASE_URL,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })

  datadogRum.setUser({
    email: window.xp.user.email,
    id: window.xp.user.id,
    projectId: window.xp.project.id
  })
}



// WEBPACK FOOTER //
// ./src/core/app.js